<script lang="ts">
	export let id = '';
</script>

<svelte:head>
	<script async src={`https://www.googletagmanager.com/gtag/js?id=${id}`}></script>
	<script data-id={id}>
		const id = document.currentScript.dataset.id;
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());
		gtag('config', id);
	</script>
</svelte:head>
